import { Alignment } from "@redotech/redo-model/email-builder";
import { starRatingWidgetParser } from "@redotech/redo-model/review/star-rating-widget-schema";
import * as z from "zod/v4";

// Schema for the widget update input that omits the fields we don't want to allow updating
const starRatingWidgetUpdateFields = z.object({
  alignment: z.nativeEnum(Alignment),
  starPadding: z.number(),
  starSize: z.number(),
  emptyStarColor: z.string(),
  filledStarColor: z.string(),
  showStarsWhenNoReviews: z.boolean(),
  starOutlineEnabled: z.boolean(),
  starOutlineColor: z.string(),
  starOutlineWidth: z.number(),
});

export const updateStarRatingWidget = {
  name: "updateStarRatingWidget" as const,
  input: z.object({ id: z.string(), widget: starRatingWidgetUpdateFields }),
  output: starRatingWidgetParser,
};
